import sdkInstanceProvider from "../sdk/sdkInstanceProvider";
import { noticeError } from "@src/helpers/monitoring";

const defaultLoyaltyDetails = {
  consentStatus: null,
  customerTierId: null,
  isLoyaltyAvailable: false,
  loyaltySdk: null
};

export async function getLoyaltyDetails(isAuthenticated) {
  if (!isAuthenticated) {
    return defaultLoyaltyDetails;
  }

  try {
    const loyaltySdk = await sdkInstanceProvider("loyalty");
    const { getCustomerTierId, getCustomerDetails } = loyaltySdk;

    const customerTierId = await getCustomerTierId();
    const { consentStatus } = await getCustomerDetails();
    const isLoyaltyAvailable = await loyaltySdk.isLoyaltyAvailable();

    return {
      consentStatus,
      customerTierId,
      isLoyaltyAvailable,
      loyaltySdk
    };
  } catch (error) {
    if (error.name !== "LoyaltyNotSupportedError") {
      noticeError(error);
    }

    return defaultLoyaltyDetails;
  }
}
